import React from "react";
import { Section1 } from "../Components/LandingPage/Section1";
export const LandingPage = () => {
  return (
    <>
      <div className="main_content LandingPage_content">
        <Section1 />
      </div>
    </>
  );
};
